import {
  ThreeDotsLoaderAnimatedSvg,
  ModalContainer,
  SectionHeader,
} from "../../components";
import { IAcceptTeamInvitationViewProps } from "./AcceptTeamInvitation";

import emailConfirmationSuccessfulImage from "../../assets/images/chat-history-thumbs-up.png";

export const View = ({
  closeModal,
  invitationCode,
  isLoadingAcceptTeamInvitation,
  isErrorAcceptTeamInvitation,
  emailConfirmationSuccessful,
  redirectToLoginCountdown,
  errorMessage,
}: IAcceptTeamInvitationViewProps) => {
  return (
    <ModalContainer
      isModalOpen={true}
      closeModal={closeModal}
      // className={"confirm-email-page--container"}
      className={`confirm-email-page--container ${
        isErrorAcceptTeamInvitation ? "confirmation-failed" : ""
      }`}
      modalHeader={
        <SectionHeader
          title={`Team Confirmation ${
            isErrorAcceptTeamInvitation ? "Failed" : ""
          }`}
          subtitle="Adding you to a new team..."
          // subTitleClassName={`${isErrorAcceptTeamInvitation ? "text-danger" : ""}`}
        />
      }
    >
      <div
        className={`form-container flex-container col justify-content--center `}
      >
        {isLoadingAcceptTeamInvitation ? (
          <div className="flex-container col justify-content--center align-items--center">
            <ThreeDotsLoaderAnimatedSvg fill={"#3b7cff"} height={30} />
            <br />
            <br />
            <h5 className="font-ctm--semibold text-danger mt-5">
              Confirming your team status...
            </h5>
          </div>
        ) : null}

        {!isErrorAcceptTeamInvitation ? null : (
          <div className="form-container__body">
            <div className="form-container__body__input-container">
              <div className="flex-container col">
                {/* <img
                      src={emailConfirmationFailedImage}
                      alt="confirmation falied"
                      className="info-image"
                    /> */}
                <h5 className="font-ctm--semibold mt-5">
                  An error occured while setting your team status...
                </h5>
                <br />
                <br />

                {/* Display any form errors here */}
                <>
                  {!errorMessage ? null : (
                    <div className="form-error--message">
                      <p className="">Error: {errorMessage}</p>
                      <br />
                      <br />
                      <br />
                      <br />
                    </div>
                  )}
                </>
              </div>
            </div>
          </div>
        )}

        {emailConfirmationSuccessful ? (
          <>
            <img
              src={emailConfirmationSuccessfulImage}
              alt="confirmation successful"
              className="info-image"
            />

            <div className="flex-box resend-link-section text-center">
              <h5 className="font-ctm--semibold">
                Your team status has been confirmed successfully. <br />
                <br />
                <span className="text-success">
                  Redirecting to homepage in {redirectToLoginCountdown}{" "}
                </span>
              </h5>
            </div>
          </>
        ) : null}
      </div>
    </ModalContainer>
  );
};
